import produce from "immer"
import { MAP_TEXT_EDITOR_FINISH_EDIT, MAP_TEXT_EDITOR_SET_TEXT } from "./map-text-editor.actions"
import type { IMapTextEditorState, ITextMapDrawing, TextMapDrawingAction } from "./map-text-editor.types"

const mapTextEditorInitialState: IMapTextEditorState = {}

export function mapTextEditorReducer(
  currentState: IMapTextEditorState | undefined,
  action: TextMapDrawingAction
): IMapTextEditorState {
  const state = currentState ?? mapTextEditorInitialState
  switch (action.type) {
    case MAP_TEXT_EDITOR_SET_TEXT:
      return setCurrentText(state, action.payload)
    case MAP_TEXT_EDITOR_FINISH_EDIT:
      return setCurrentText(state)
    default:
      return state
  }
}

function setCurrentText(currentState: IMapTextEditorState, textDrawing?: ITextMapDrawing): IMapTextEditorState {
  return produce(currentState, (draftState: IMapTextEditorState) => {
    draftState.currentText = textDrawing
  })
}
